export enum WebRefType {
    ReadSample = 'READSAMPLE',
    SoundSample = 'SOUNDSAMPLE',
    VideoSample = 'VIDEOSAMPLE',
    youtube = 'YOUTUBE',
    vimeo = 'VIMEO',
    Unknown = 'UNKNOWN'
}